import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { store } from './store/store';
import { queryClient } from './queryClient';
import { AppRoutes } from './routes';
import RoomCheckWrapper from '@/shared/components/layout/RoomCheckWrapper';
import { PaymentUpdatesProvider } from '@/shared/contexts/PaymentUpdatesContext';
import { PendingApprovalsProvider } from '@/shared/contexts/PendingApprovalsContext';
import { TenantProvider } from '@/shared/contexts/TenantContext';
import { AuthProvider } from '@/shared/contexts/AuthContext';
import { LayoutDataProvider } from '@/shared/contexts/LayoutDataContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <TenantProvider>
          <Router>
            <ThemeProvider>
              <AuthProvider>
                <LayoutDataProvider>
                  <PaymentUpdatesProvider>
                    <PendingApprovalsProvider>
                      <RoomCheckWrapper>
                        <AppRoutes />
                      </RoomCheckWrapper>
                    </PendingApprovalsProvider>
                  </PaymentUpdatesProvider>
                </LayoutDataProvider>
              </AuthProvider>
            </ThemeProvider>
          </Router>
        </TenantProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;